import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('visual-placeholder')
export class VisualPlaceholder extends LitElement {

	static styles = css`
	  :host {
		display: flex;
		justify-content: center;
		align-items: center;
	  }
	  h2 {
		font: var(--font-big-title);
		color: var(--color-grey6);
		text-transform: uppercase;
		letter-spacing: 10px;
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<h2></h2>
		`;
	}
}
